





























































































































































import eventBus from "@/utils/bus";
import { createSalaryOrderData, createSalaryOrderApi } from "@/api/salary";
import commonStaffSelector from "@/components/commonStaffSelector.vue";
import { Vue, Component } from "vue-property-decorator";
@Component({
  name: "createSettlementDialog",
  components: {
    commonStaffSelector,
  },
})
export default class extends Vue {
  form = {
    name: "",
    date: [] as string[],
    staff_ids: [] as number[],
    staff_items: [] as any[],
    payment_date: "",
    month_date: "",
  };
  rules = {
    name: [{ required: true, message: "请输入结算名称", trigger: "name" }],
    date: [{ required: true, message: "请输入结算区间", trigger: "change" }],
    staff_ids: [
      { required: true, message: "请输入结算人员", trigger: "change" },
    ],
    payment_date: [
      { required: true, message: "请选择发薪日期", trigger: "change" },
    ],
    month_date: [
      { required: true, message: "请选择工资所属月", trigger: "change" },
    ],
  };
  mainDialogVisible: boolean = false;
  unsetDialogVisible: boolean = false;
  unsetDialogData: string = "";
  waitDialogVisible: boolean = false;
  pickerOptions = {
    disabledDate(time: any) {
      const year = new Date().getFullYear(); //获取当前年份
      const month = new Date().getMonth() + 1; //获取当前月份
      const tot = new Date(year + "-" + month + "-1").getTime(); //获取当前年月转成时间戳
      // console.log(year, month, new Date(tot).getTime());
      return time.getTime() > tot;
    },
  };
  openDialog() {
    this.mainDialogVisible = true;
  }
  closeDialog() {
    this.form = {
      name: "",
      date: [],
      staff_ids: [],
      staff_items: [],
      payment_date: "",
      month_date: "",
    };
    this.mainDialogVisible = false;
  }
  closeUnsetDialog() {
    this.unsetDialogData = "";
    this.unsetDialogVisible = false;
  }
  closeWaitDialog() {
    this.unsetDialogVisible = false;
    this.waitDialogVisible = false;
    this.mainDialogVisible = false;
    this.$emit("change");
  }
  handleStaffChange(arr: any[]) {
    this.form.staff_items = arr;
    this.form.staff_ids = arr.map((item: any) => {
      return item.staff_id;
    });
  }
  handleSubmit(type: string) {
    (this.$refs["mainForm"] as Vue & { validate: Function }).validate(
      (valid: boolean) => {
        if (valid) {
          if (
            new Date(this.form.date[1].replace(/-/g, "/")).getTime() -
              new Date(this.form.date[0].replace(/-/g, "/")).getTime() >
            365 * 24 * 60 * 60 * 1000
          ) {
            this.$message({
              type: "warning",
              message: "区间不可大于一年",
            });
            return false;
          }
          const params: createSalaryOrderData = {
            ignore_not_set: type === "force",
            name: this.form.name,
            start_date: this.form.date[0],
            end_date: this.form.date[1],
            staff_ids: this.form.staff_ids,
            payment_date: this.form.payment_date,
            belong_month: this.form.month_date,
          };
          createSalaryOrderApi(params).then((res: any) => {
            if (res.error_code === 0) {
              this.unsetDialogVisible = false;
              this.waitDialogVisible = true;
            } else if (res.error_code === 21026013) {
              this.unsetDialogVisible = true;
              this.unsetDialogData = res.message;
            }
          });
        }
      }
    );
  }
  toStaffSalary() {
    this.$router.push({
      name: "staffSalary",
    });
  }
}
